import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';

import {
  JA_CRITICAL_FONT_SUBSET_URLS,
  JA_FONT_CSS_URL,
} from '@/shared/consts/fonts';

/**
 * 언어 셀렉터가 열리는 순간(=언어를 바꿀 의도 신호) ja 폰트를 미리 받아둔다.
 * 언어 전환은 풀 리로드라 전환 후 페이지가 폰트를 새로 요청하는데,
 * 여기서 미리 HTTP 캐시(immutable)에 넣어두면 전환 직후에도 스왑이 보이지 않는다.
 */
export function usePrefetchJaFonts(isOpen: boolean) {
  const { locale } = useRouter();
  const hasPrefetched = useRef(false);

  useEffect(() => {
    // ja 페이지는 _document가 이미 로드하므로 프리페치 불필요
    if (!isOpen || hasPrefetched.current || locale === 'ja') return;
    hasPrefetched.current = true;

    [JA_FONT_CSS_URL, ...JA_CRITICAL_FONT_SUBSET_URLS].forEach(href => {
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = href;
      link.as = href.endsWith('.css') ? 'style' : 'font';
      // _document의 stylesheet/preload와 동일한 CORS 모드여야 캐시가 재사용된다
      link.crossOrigin = 'anonymous';
      document.head.append(link);
    });
  }, [isOpen, locale]);
}
